import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import Input from './modules/Input'
import Output from './modules/Output'
import Shopping from './modules/Shopping'
import Catering from './modules/Catering'
import Order from './modules/Order'
import Delivery from './modules/Delivery'

import Contribution from './modules/Contribution'
const modules = {
  Input,
  Output,
  Shopping,
  Catering,
  Order,
  Delivery,

  Contribution,
}

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: true,
  // url_base: 'http://localhost:8083/',
  url_base: 'https://caritastacnamoq.com/api/',

}
const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  }
}



export default new Vuex.Store({
  state,
  mutations,
  modules
})